import { createSvgIcon } from '@mui/material'

export const Location = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="512"
    height="512"
    role="img"
    aria-label="Location pin"
  >
    <defs>
      <mask
        id="pinCut"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="512"
        height="512"
      >
        <rect x="0" y="0" width="512" height="512" fill="white" />
        <path
          d="M 257 406 L 147.5 228.5 A 128.6 128.6 0 1 1 366.5 228.5 L 257 406 Z"
          fill="black"
          stroke="black"
          strokeWidth="27"
          strokeLinejoin="round"
        />
      </mask>
    </defs>
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="15"
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      <ellipse cx="257" cy="418" rx="128.5" ry="53.5" mask="url(#pinCut)" />
      <path d="M 257 406 L 147.5 228.5 A 128.6 128.6 0 1 1 366.5 228.5 L 257 406 Z" />
      <circle cx="257" cy="161" r="41.5" />
    </g>
  </svg>,
  'Location'
)
